{
  "it": {
    "choice": {
      "actions": {
        "delete_choice": "Rimuovi opzione",
        "delete_choice_list": "Rimuovi elenco opzioni"
      },
      "labels": {
        "not_selected": "Non selezionato",
        "selected": "Selezionato"
      },
      "messages": {
        "delete_choice": "È sicuro di voler rimuovere l'opzione {title}?",
        "delete_choice_list": "È sicuro di voler rimuovere l'elenco opzioni {title}?"
      },
      "toasts": {
        "create": "Opzione creata con successo",
        "delete": "Opzione eliminata con successo",
        "update": "Opzione aggiornata con successo"
      }
    }
  }
}
